import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DialogAddNewRuleComponent } from '@app/modules/guest-experience/components/dialog-add-new-rule/dialog-add-new-rule.component';
import { DirectPlan } from '../../models/direct-subscription.interface';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';
import { PayoutMethod, PayoutMethodProvider, PayoutMethodsService } from '../../services/payout-methods.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-subscribe-to-direct',
  templateUrl: './dialog-subscribe-to-direct.component.html',
  styleUrls: ['./dialog-subscribe-to-direct.component.scss'],
})
export class DialogSubscribeToDirectComponent implements OnInit {
  activatingPlan: boolean = false;

  directSub$ = this.directSubService.subscriptionStatus$;

  loading: boolean = true;
  needsToAddStripeAccount: boolean = false;
  needsToAddAdyenAccount: boolean = false;
  payoutMethods: PayoutMethod[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogAddNewRuleComponent>,
    private directSubService: DirectSubscriptionService,
    private payoutMethodsService: PayoutMethodsService
  ) { }

  ngOnInit(): void {
    this.fetchExistingPayoutMethodsData();
  }

  fetchExistingPayoutMethodsData() {
    // We want to fetch data about existing payout methods, to know whether the user needs to add a payout method before they can switch
    this.payoutMethodsService.fetchPayoutMethods().subscribe((res) => {
      this.loading = false;

      this.payoutMethods = res;

      // If the user has no payout methods matching the plan they want to activate, they need to add one before they can switch
      this.directSub$.subscribe((sub) => {
        const plan = sub.plan;

        if (plan === DirectPlan.Premium) {
          this.needsToAddAdyenAccount = !this.payoutMethods.some((payoutMethod) => {
            return payoutMethod.provider === PayoutMethodProvider.ADYEN && payoutMethod.all_properties;
          });
        }

        if (plan === DirectPlan.Basic) {
          this.needsToAddStripeAccount = !this.payoutMethods.some((payoutMethod) => {
            return payoutMethod.provider === PayoutMethodProvider.STRIPE_OAUTH && payoutMethod.all_properties;
          });
        }
      });
    });
  }

  activatePlan() {
    this.activatingPlan = true;

    this.directSubService.activateDirectSubscription().subscribe((res) => {
      this.dialogRef.close(true);
    });
  }
}
